import { gql, useMutation } from '@apollo/client';

const INSERT_TICKET = gql`
mutation InsertTicket($description: Text = "", $priority: Text = "", $raisedBy: Int4 = "", $title: Text = "", $type: Text = "", $organisationId: Uuid = "") {
  v2InsertTickets(
    objects: {description: $description, priority: $priority, raisedBy: $raisedBy, title: $title, type: $type, organisationId: $organisationId}
  ) {
    affectedRows
  }
}
`;

const useInsertTicket = () => {
  const [insertTicket, { loading, error }] = useMutation(INSERT_TICKET,
    {
      context: {
        headers: {
          'x-hasura-role': 'learner'
        }
      }
    }
  );

  return { insertTicket, loading, error };
}

export default useInsertTicket;